import { render, staticRenderFns } from "./AnonymousContent.vue?vue&type=template&id=64457f9a&"
import script from "./AnonymousContent.vue?vue&type=script&lang=js&"
export * from "./AnonymousContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports